module.exports = __webpack_public_path__ + "img/NP.ca032b08.png";